import { useQuery } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axios/editorInstance'
import extract from '@pepper/utils/src/function/extract'
import { DocumentTypes } from '@pepper/utils/src/function/getEditorApiEndpoint'

import { EditorContent } from '../../types'

interface Parameter {
  data: {
    pepperDocId?: string
  }
}

type Response = {
  content: EditorContent
  current_version: {
    id: string
    // * * available only on yjs documents
    clock?: number
  }
  notes?: {
    title: string
  }
  last_modified_by: string
  word_count: number
  is_yjs_enabled: boolean
  use_yjs_v2?: boolean
  type: DocumentTypes
  'x-editor-token': string
  metadata?: {
    title: string
  }
}

export async function getBriefContent(data: Parameter['data']) {
  try {
    const response = await axios.get(`/v1/editor/${data.pepperDocId}`)
    return extract.data<Response>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

// TODO: @jibin2706 rename files & hook to useGetDocContent
export function useGetBriefContent({ data }: Parameter) {
  return useQuery({
    queryKey: ['doc', 'content', data.pepperDocId],
    queryFn: () => getBriefContent(data),
    enabled: data.pepperDocId ? true : false,
  })
}
